module.exports = __webpack_public_path__ + "static/media/Monday_Step1_Image28.8c4a6448.webp";